module.exports = __webpack_public_path__ + "img/nature_people.f69b98cd.svg";